module.exports = __webpack_public_path__ + "static/flags/CE-4f598ddfa13009f806a594b69076ad0b.gif";